import React, { useState } from "react";
import { DecisionDetailsCard } from "./DecisionCard";
import { Referral } from "types";
import RespondBackSection from "./RespondBackSection";
import FileViewer from "components/file-components/fileViewer2";

export default function ReferralDecision({
  referral,
  onDecsionCreated,
  setActiveTab,
  handleAddAssetDecisionClick,
  handleAddAssetRecoveryDecisionClick,
  handleCreateTerminationRequestClick,
}: {
  referral: Referral;
  onDecsionCreated: (res: any) => void;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  handleAddAssetDecisionClick?: () => void;
  handleAddAssetRecoveryDecisionClick?: () => void;
  handleCreateTerminationRequestClick?: () => void;
}) {
  const [isFileViewerOpen, setIsFileViewerOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<{
    name: string;
    size: number;
    url: string;
    isFetched: boolean;
    type: string;
    uuid: string;
  } | null>(null);

  const fileRowProps = {
    fileViewerNumber: 2,
    setFileViewer2: setIsFileViewerOpen,
    setSelectedApplicantDocument: (document: any) => {
      setSelectedDocument(document);
      setIsFileViewerOpen(true);
    },
  };
  return (
    <div>
      {referral?.action_status !== "Pending" ? (
        <div className="flex w-full gap-2">
          <DecisionDetailsCard
            asset_recovery_request_document={
              referral?.asset_recovery_request_documents
            }
            asset_recovery_request_date={referral?.asset_recovery_request_date}
            asset_reovery_charge={referral?.asset_reovery_charge}
            prosecutor_decision_on_asset_recovery={
              referral?.prosecutor_decision_on_asset_recovery
            }
            fileRowProps={fileRowProps}
            referralId={referral?.id}
            is_prohabition_request={referral?.is_prohabition_requested}
            document_details={referral?.prosecutor_decision_documents as File[]}
            document_summary={referral?.decision_summary}
            assigned_prosecutor={referral?.assigned_prosecutor}
            forward_status={referral?.forward_status}
            action_status={referral?.action_status}
            document_date={referral?.decision_date as string}
            file_histories={
              referral?.file_histories
                ? referral.file_histories.map((fh) => ({
                    id: fh.id ?? "",
                    file_type: fh.file_type,
                    old_file: fh.old_file,
                    new_file: fh.new_file ?? "",
                    old_summary: (fh as any).old_summary ?? null,
                    new_summary: (fh as any).new_summary ?? "",
                    old_date: (fh as any).old_date ?? null,
                    new_date: fh.new_date,
                    changed_at: fh.changed_at ?? "",
                  }))
                : null
            }
            prohabition_request_date={
              referral?.prohabition_request_date as string
            }
            prohabition_request_document={
              (referral?.prohibition_request_documents as File[]) ?? null
            }
            prohabition_request_summary={
              referral?.prohabition_request_summary as string
            }
            onDecsionCreated={onDecsionCreated}
            setActiveTab={setActiveTab}
            handleAddAssetDecisionClick={handleAddAssetDecisionClick}
            handleAddAssetRecoveryDecisionClick={
              handleAddAssetRecoveryDecisionClick
            }
            referral={referral}
            handleCreateTerminationRequestClick={
              handleCreateTerminationRequestClick
            }
          />
          {!["pending"].includes(referral?.action_status.toLowerCase()) && (
            <RespondBackSection
              referralId={referral?.id}
              fileRowProps={fileRowProps}
              type="referral"
            />
          )}
        </div>
      ) : (
        <div>No Decision Added</div>
      )}
      <FileViewer
        selectedApplicantDocument={selectedDocument || undefined}
        isPopupOpen={isFileViewerOpen}
        setIsPopupOpen={setIsFileViewerOpen}
      />
    </div>
  );
}
